import React from 'react';
import { ChevronDown } from 'lucide-react';

export const STANDARD_RELATIONSHIPS = [
  'Parent',
  'Spouse / Partner',
  'Child',
  'Sibling',
  'Legal Guardian',
  'Professional Caregiver / Home Health Aide',
  'Other Relative',
  'Other Non-Relative',
];

const RelationshipTypeSelect = ({ value, onChange, className = '', hasError = false }) => {
  return (
    <div className={`relative ${className}`}>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className={`input appearance-none pr-9 ${hasError ? 'input-error' : ''}`}
      >
        <option value="">Select a relationship…</option>
        {STANDARD_RELATIONSHIPS.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
    </div>
  );
};

export default RelationshipTypeSelect;
